export class LabTestDataModel {
  public id: string;
  public labTestName: string;
  public screenType: any;
  public priority: number;
  public description: string;
  public costPrice: number;
  public labTestCategoryId: string;
  public labTestCategoryName: string;
  public labTestId: string;
  public centreLabtestId: string;

  public labtestType: any;
  public manufacturerID: string;
  public centreIds: string[];

  constructor(
    id: string = '',
    name: string = '',
    screenType: any = null,
    priority: number = 0,
    labTestCategoryName: string = '',
    description: string = '',
    costPrice: number = 0,
    labTestCategoryId: string = '',
    labTestId: string = '',
    centreLabtestId: string = '',
    labtestType: any = null,
    manufacturerID: string = '',
  ) {
    this.id = id;
    this.labTestName = name;
    this.screenType = screenType;
    this.priority = priority;
    this.description = description;
    this.costPrice = costPrice;
    this.labTestCategoryId = labTestCategoryId;
    this.labTestId = labTestId;
    this.centreLabtestId = centreLabtestId;

    this.labtestType = labtestType;
    this.manufacturerID = manufacturerID;
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/master-data/lab-test-data.model.ts